<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue';
import { AppButton, AppTypography } from '~/components/base';
import useResendForgotPasswordCode from '~/composables/auth/forgot-password/useResendForgotPasswordCode';
import ResendForgotPasswordCodeForm from '~/utils/contents/auth/forms/ResendForgotPasswordCodeForm';
import { $formatToDigitalTime } from '~/utils/formatters';

const { email } = defineProps<{
  email: string;
}>();
const { timer, loading, canResend, resend } = useResendForgotPasswordCode();

const resendButtonLabel = computed((): string => {
  if (canResend.value) {
    return ResendForgotPasswordCodeForm.actions.submitButton.label;
  }

  return `Resend in ${$formatToDigitalTime(timer.timeLeft.value)}`;
});

const onSubmit = async (): Promise<void> => {
  if (canResend.value) {
    await resend(email);
  }
};

onMounted(() => {
  timer.initialize();
});

onUnmounted(() => {
  timer.pause();
});
</script>

<template>
  <div class="resend-verification-form flex items-center justify-center gap-2">
    <AppTypography type="body">{{
      ResendForgotPasswordCodeForm.label
    }}</AppTypography>
    <AppButton
      variant="text"
      class="app-btn--plain-text app-btn--resend p-0!"
      :data-testid="
        ResendForgotPasswordCodeForm.actions.submitButton.dataTestId
      "
      :disabled="loading || !canResend"
      @click="onSubmit()"
      ><b>{{ resendButtonLabel }}</b></AppButton
    >
  </div>
</template>

<style></style>
